import styles from './ExpandableContent.module.scss';

type Props = {
  expanded: boolean;
  children: React.ReactNode | React.ReactNode[];
};

export default function ExpandableContent({ expanded, children }: Props) {
  return (
    <div className={`${styles.wrapper} ${expanded ? styles.expanded : ''}`}>
      <div className={styles.children}>{children}</div>
    </div>
  );
}
